import React from 'react'

export default function LoadingIndicator(props) {
  return (
    <div uk-spinner="true" {...props}>
      <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" ratio="1">
        <circle fill="none" stroke="#000" cx="15" cy="15" r="14" />
      </svg>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/LoadingIndicator/LoadingIndicator.js